import {useSelector} from "react-redux";
import {Config} from "../../misc";
import SidePanel from "./SidePanel";
import DoorPanel from "./DoorPanel";
import TopPanel from "./TopPanel";


/**
 * Preview
 * @param props
 * @param {{width: number, height: number}} props.dimensions Dimensions
 * @returns {JSX.Element}
 * @constructor
 */
export default function Preview(props) {
    const store = useSelector(({main}) => ({
        product: main.products.find(p => p.id === props.config.product?.value)
    }))
    const scale = 3
    const config = new Config(props.dimensions, props.config)

    const getSize = (size) => {
        return `${size * scale}px`;
    }

    const topHeight = config.topHeight()
    const leftWidth = config.leftWidth()
    const rightWidth = config.rightWidth()
    const doorWidth = config.doorWidth()

    const aspectRatio = props.dimensions.width / props.dimensions.height

    return (
        <div className="preview">

            <div style={{maxWidth: 600, margin: '0 auto'}}>
                <div
                    className="preview__wrapper"
                    style={{
                        aspectRatio: `${props.dimensions.width}/${props.dimensions.height}`,
                        borderColor: props.config.color?.color,
                        // borderWidth: `${aspectRatio * 15}px`,
                    }}
                >
                    <div
                        className="preview__container"
                        style={{
                            // width: getSize(props.dimensions.width),
                            // width: '100%',
                            // height: getSize(props.dimensions.height),
                        }}
                    >
                        {!!props.config.topEnabled && !!topHeight && (
                            <div
                                className="preview__top"
                                style={{}}
                            >
                                <TopPanel config={props.config} dimensions={props.dimensions}/>
                                <LeftLegendComponent value={topHeight}/>
                            </div>
                        )}
                        <div className="preview__center">
                            {props.config.align !== 'left' && !!leftWidth && (
                                <div className="preview__left">
                                    <SidePanel config={props.config} dimensions={props.dimensions}/>
                                    <BottomLegendComponent value={leftWidth}/>
                                </div>
                            )}
                            <div
                                className="preview__doorWrapper"
                                style={{
                                    width: `${(100 * (Number(props.config.width) + 10)) / props.dimensions.width}%`,
                                }}
                            >
                                {!props.config.topEnabled && (
                                    <div
                                        className="preview__top"
                                        style={{}}
                                    >
                                        <TopPanel color={props.config.color}/>
                                    </div>
                                )}
                                <div
                                    className="preview__door"
                                    style={{
                                        width: '100%',
                                        aspectRatio: `${Number(props.config.width) + 10}/${props.config.height}`
                                        // width: getSize(props.config.width),
                                        // height: getSize(props.config.height),
                                    }}
                                >
                                    <DoorPanel
                                        product={store.product}
                                        reverse={props.config.openingDirection !== 'left'}
                                    />
                                    <BottomLegendComponent value={doorWidth}/>
                                </div>
                            </div>
                            {props.config.align !== 'right' && !!rightWidth && (
                                <div className="preview__right">
                                    <SidePanel config={props.config} dimensions={props.dimensions}/>
                                    <BottomLegendComponent value={rightWidth}/>
                                </div>
                            )}

                            {/*<div className="preview__heightLegend">*/}
                            {/*  {!props.config.topEnabled && !!topHeight && (*/}
                            {/*    <div style={{position: 'relative', flex: 1}}>*/}
                            {/*      <LeftLegendComponent value={topHeight}/>*/}
                            {/*    </div>*/}
                            {/*  )}*/}
                            {/*  <div*/}
                            {/*    style={{*/}
                            {/*      position: 'relative',*/}
                            {/*      // height: getSize(props.config.height),*/}
                            {/*      // aspectRatio: `${props.config.width}/${props.config.height}`*/}
                            {/*    }}*/}
                            {/*  >*/}
                            {/*    <LeftLegendComponent value={props.config.height}/>*/}
                            {/*  </div>*/}
                            {/*</div>*/}


                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}


function LeftLegendComponent({value}) {
    return (
        <div className="preview__leftLegend">
            {value} cm
        </div>
    )
}


function BottomLegendComponent({value}) {
    return (
        <div className="preview__bottomLegend">
            {value} cm
        </div>
    )
}



